import { useEffect, useState } from "react";
import { Container, Flex, Box } from "@chakra-ui/react";
import { ObjectApplicationForm } from "./Form";
import { MyTable } from "../../../Components/Table";
import { Pagination } from "../../../Components/Pagination";
import { Navigation } from "../../../Components/Navigation";
import { IPaginationRequest } from "../../../Api/IncidentManagement/interface";
import { IMyTableColumn, IResponse } from "../../../Components/Table/interface";
import { getObjectApplicationsWithPagination } from "../../../Api/IncidentManagement";
import { useAuth } from "../../../Hook/useAuth";
import { Menu } from "../../../Components/Menu";
import { MENU_KEYS } from "../../../Api/Constants";
import { Header } from "../../../Components/Header/Header";

export function BackofficeObjectApplication() {
    const { accessToken } = useAuth()
    const [currentPage, setCurrentPage] = useState(1)
    const [loading, setLoading] = useState(true);    
    const [reloadTable, setReloadTable] = useState(false);    
    const [id, setObjectApplicationToEdit] = useState(0); 
    const [data, setData] = useState<IResponse>({} as IResponse)
    const [showComponentForm, setShowObjectApplicationForm] = useState(false);

    const currentMenuKey = MENU_KEYS.ObjectApplicationMenuKey;

    const tableColumns: IMyTableColumn[] = [
        {
            key: "name",
            title: "Nome",
            dataIndex: "name", 
        },
        {
            key: "application",
            title: "Produto",
            dataIndex: "applicationName",
            render: (row, dataIndex) => row?.[dataIndex]
        }
    ]

    const handleObjectApplicationForm = () => {
        setShowObjectApplicationForm(!showComponentForm)

        if(id) {
            handleTableRowClick(0)
        }
    }

    const handleTableRowClick = (row: any) => {
        setObjectApplicationToEdit(row)
        setShowObjectApplicationForm(!showComponentForm)
    }

    const handleReloadTable = () => {
        setReloadTable(!reloadTable)
        setLoading(true)
        handleObjectApplicationForm()

        if(id) {
            handleTableRowClick(0)
        }
    }

    useEffect(()=>  {
        const loadObjectApplications = async ({ page, pageSize = 10 }: IPaginationRequest) => {
            try {
                if(!loading) {
                    setLoading(true)
                } 

                const response = await getObjectApplicationsWithPagination({page, pageSize}, accessToken)
                if(response.status === 200) {
                    setData(response.data)
                    setCurrentPage(response.data?.pagination?.currentPageNumber)
                }
            } catch (error) {
            } finally {
                setLoading(false)
            }
        }
        if(accessToken){
            loadObjectApplications({page: currentPage, pageSize: 10});
        }
    }, [reloadTable, currentPage, accessToken])

    return(
        <Container maxW='container.xl' p={8}>
            <Navigation handleAddAction={handleObjectApplicationForm} addButtonText="Adicionar Objetos Aplicacionais" showSettingsButton={false} />
            <Flex>
                <Menu activeKey={currentMenuKey}></Menu>
                
                <Box bg='' w="100%" 
                    borderRightWidth='1px'
                    borderTopWidth='1px'
                    borderBottomWidth='1px'
                    borderTopRightRadius='md'
                    borderBottomRightRadius='md'>
                    <Header title="Adicionar ou remover Objetos Aplicacionais"/>

                    <MyTable 
                        data={data} 
                        loading={loading} 
                        columns={tableColumns} 
                        handleTableRowClick={handleTableRowClick}
                    /> 

                    <Box marginLeft={4}>
                        <Pagination 
                            onPageChange={page => setCurrentPage(page)} 
                            currentPage={currentPage} 
                            totalCount={data?.pagination?.pageRecordNumber} 
                            pageSize={data?.pagination?.totalRecords}
                            totalPageCount={data?.pagination?.totalPages}
                            hasNextPage={data?.pagination?.hasNextPage}
                            hasPreviousPage={data?.pagination?.hasPreviousPage}
                        /> 
                    </Box>
                </Box>

                <ObjectApplicationForm 
                    isOpen={showComponentForm} 
                    setIsOpen={handleObjectApplicationForm} 
                    handleReloadTable={handleReloadTable} 
                    id={id} 
                />
            </Flex>
        </Container>
    )
}